import { ModalWidthEnum, TMobileDrawerProps } from '@landlord-tech/ui-kit-opp';
import useDeviceType from 'hooks/useDeviceType';
import Modal, { MobileDrawer } from '..';

const AdaptiveModal: React.FC<TMobileDrawerProps> = props => {
  const { isMobile } = useDeviceType();
  const { okButtonProps, confirmLoading } = props;
  if (isMobile) {
    return (
      <MobileDrawer
        {...props}
        okButtonProps={{
          ...okButtonProps,
          loading: confirmLoading,
        }}
      />
    );
  }

  return <Modal size={ModalWidthEnum.Medium} {...props} />;
};

export default AdaptiveModal;
